import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import moment from "moment/moment";

import {subtractWorkDays} from '../services/DateModule';

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'REPLENISHMENT/INIT',
    FETCH_REPLENISHMENTS: 'REPLENISHMENT/FETCH_REPLENISHMENTS',
    FETCH_REPLENISHMENTS_SUCCESS: 'REPLENISHMENT/FETCH_REPLENISHMENT_SUCCESS',
    FETCH_MODULES: 'REPLENISHMENT/FETCH_MODULES',
    FETCH_MODULES_SUCCESS: 'REPLENISHMENT/FETCH_MODULES_SUCCESS',
    UPDATE_REPLENISHMENT_QUERY: 'REPLENISHMENT/UPDATE_REPLENISHMENT_QUERY',
    UPDATE_CREATED_BETWEEN: 'REPLENISHMENT/UPDATE_CREATED_BETWEEN',
    UPDATE_MODULE_FILTER: 'REPLENISHMENT/UPDATE_MODULE_FILTER',
    UPDATE_PROCESSING_STATUS_FILTER: 'REPLENISHMENT/UPDATE_PROCESSING_STATUS_FILTER',
    CHANGE_PAGE: 'REPLENISHMENT/CHANGE_PAGE',
    SET_PAGE_SIZE: 'REPLENISHMENT/SET_PAGE_SIZE',
    UPDATE_SORT_PROPERTIES: 'REPLENISHMENT/UPDATE_SORT_PROPERTIES'
};

export const initialState = fromJS({
    replenishments: [],
    filters: {
        processingStatus: 'IN_PROGRESS',
        createdAfter: moment().subtract(2, "month").utc(),
        createdBefore: moment().utc(),
        modulesSelected: []
    },
    sortProperties: {
        propertyToSortBy: 'id',
        sortDirection: 'asc'
    },
    pagination: {
        page: 0,
        pageSize: 25,
        totalPages: 0,
        totalElements: 0
    },
    query: '',
    modules: []
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_REPLENISHMENTS_SUCCESS:
            return state.set('replenishments', fromJS(action.replenishments))
                .setIn(['pagination', 'totalPages'], fromJS(action.totalPages))
                .setIn(['pagination', 'totalElements'], fromJS(action.totalElements));
        case types.FETCH_MODULES_SUCCESS:
            return state.set('modules', fromJS(action.modules));
        case types.UPDATE_REPLENISHMENT_QUERY:
            return state.set('query', action.query).setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_CREATED_BETWEEN:
            return state.setIn(['filters', 'createdAfter'], fromJS(action.createdAfter))
                .setIn(['filters', 'createdBefore'], fromJS(action.createdBefore));
        case types.UPDATE_PROCESSING_STATUS_FILTER:
            return state.setIn(['filters', 'processingStatus'], action.status).setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_MODULE_FILTER:
            return state.setIn(['filters', 'modulesSelected'], fromJS(action.modulesSelected));
        case types.CHANGE_PAGE:
            return state.setIn(['pagination', 'page'], fromJS(action.page));
        case types.SET_PAGE_SIZE:
            return state.setIn(['pagination', 'pageSize'], fromJS(action.pageSize))
                .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_SORT_PROPERTIES:
            return state.setIn(['sortProperties', 'propertyToSortBy'], fromJS(action.propertyToSortBy))
                .setIn(['sortProperties', 'sortDirection'], fromJS(action.sortDirection));
        default:
            return state
    }
};

export const initialize = () => {
    return (dispatch) => {
        dispatch(fetchReplenishments());
    }
};

export const fetchReplenishments = () => {
    return function (dispatch, getState) {

        const {query, filters, pagination, sortProperties} = getState().replenishment.toJS();

        const formatCreatedAfter = filters.createdAfter.utc().toISOString();

        const formatCreatedBefore = filters.createdBefore.utc().toISOString();

        let moduleString = filters.modulesSelected.join(',');

        const path = __API__ +
            `/api/ui/releasedreplenishment?search=${query}` +
            `&processingStatus=${filters.processingStatus}` +
            `&page=${pagination.page}&pageSize=${pagination.pageSize}` +
            `&propertyToSortBy=${sortProperties.propertyToSortBy}&sortDirection=${sortProperties.sortDirection}&createdAfter=${formatCreatedAfter}` +
            `&createdBefore=${formatCreatedBefore}` +
            `&modules=${moduleString}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(data => {
                dispatch(fetchReplenishmentsSuccess(data.content, data.totalPages, data.totalElements));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchReplenishmentsSuccess = (replenishments, totalPages, totalElements) => {
    return {
        type: types.FETCH_REPLENISHMENTS_SUCCESS,
        replenishments: replenishments,
        totalPages: totalPages,
        totalElements: totalElements
    };
};

export const fetchModules = () => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/module';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(modules => {
                dispatch(fetchModulesSuccess(modules));
            })
            .catch(error => {
                console.log(error)
            });
    }
};

export const fetchModulesSuccess = (modules) => {
    return {
        type: types.FETCH_MODULES_SUCCESS,
        modules: modules
    };
};

export const updateModuleFilter = (modulesSelected) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULE_FILTER,
            modulesSelected: modulesSelected
        });
        dispatch(fetchReplenishments());
    }
};

export const updateReplenishmentQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_REPLENISHMENT_QUERY,
            query: query
        });
        dispatch(fetchReplenishments());
    }
};

export const showAllOverdueSince = (workDays) => {

    const createdAfter = subtractWorkDays(moment().utc(), 1000);
    const createdBefore = subtractWorkDays(moment().utc(), workDays);

    return function (dispatch) {
        dispatch(updateCreatedBetween(createdAfter, createdBefore));
        dispatch(updateStatusFilter('IN_PROGRESS'));
        dispatch(fetchReplenishments());
    }
};

export const updateCreatedBetween = (createdAfter, createdBefore) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_CREATED_BETWEEN,
            createdAfter: createdAfter,
            createdBefore: createdBefore
        });
        dispatch(fetchReplenishments());
    }
};

export const updateStatusFilter = (status) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_PROCESSING_STATUS_FILTER,
            status: status
        });
        dispatch(fetchReplenishments());
    };
};

export const updatePage = (newPage) => {
    return {
        type: types.CHANGE_PAGE,
        page: newPage
    }
};

export const changePage = (newPage) => {
    return function (dispatch) {
        dispatch(updatePage(newPage));
        dispatch(fetchReplenishments());
    }
};

export const setPageSize = (pageSize) => {
    return function (dispatch) {
        dispatch({
            type: types.SET_PAGE_SIZE,
            pageSize: pageSize
        });
        dispatch(fetchReplenishments());
    }
};

export const restoreReplenishment = (replenishmentId) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/releasedreplenishment/${replenishmentId}/restore`;

        const command = {
            replenishmentId: replenishmentId
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchReplenishments());
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchReplenishmentsSuccess([]));
            });
    }
};

export const markReplenishmentAsShipped = (replenishmentId) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/releasedreplenishment/${replenishmentId}/markasshipped`;

        const command = {
            replenishmentId: replenishmentId
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchReplenishments());
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchReplenishmentsSuccess([]));
            });
    }
};

export const markReplenishmentAsUnshipped = (replenishmentId) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/releasedreplenishment/${replenishmentId}/markasunshipped`;

        const command = {
            replenishmentId: replenishmentId
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchReplenishments());
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchReplenishmentsSuccess([]));
            });
    }
};

export const updateSortProperty = (propertyToSortBy) => {
    return function (dispatch, getState) {
        const {sortProperties} = getState().replenishment.toJS();
        const asc = 'asc';
        const desc = 'desc';
        let sortDirection = 'asc';
        if (sortProperties.propertyToSortBy === propertyToSortBy) {
            sortDirection = sortProperties.sortDirection === asc ? desc : asc;
        }
        dispatch({
            type: types.UPDATE_SORT_PROPERTIES,
            propertyToSortBy: propertyToSortBy,
            sortDirection: sortDirection
        });
        dispatch(fetchReplenishments());
    }
};


// WEBPACK FOOTER //
// ./src/admin/replenishment/reducer.js